<template>
	<themed-tabs
		v-model="activeTab"
		:tabs="tabConfig"
		@tab-change="handleTabChange"
	/>
</template>

<script>
import ThemedTabs from '../ThemedTabs.vue';
import PropertiesTabContent from './PropertiesTabContent.vue';
import KeyDatesTabContent from './KeyDatesTabContent.vue';

export default {
	name: 'PropertiesTable',
	
	components: {
		ThemedTabs,
	},
	
	props: {
		projects: {
			type: Array,
			required: true
		},
		sites: {
			type: Array,
			required: true
		}
	},
	
	data() {
		return {
			activeTab: 'properties'
		}
	},
	
	computed: {
		tabConfig() {
			return [
				{
					label: 'Properties',
					value: 'properties',
					count: this.projects.length + this.sites.length,
					component: PropertiesTabContent,
					props: {
						projects: this.projects,
						sites: this.sites
					}
				},
				{
					label: 'Key Dates',
					value: 'key-dates',
					component: KeyDatesTabContent,
					props: {
						sites: this.sites
					}
				}
			];
		}
	},
	
	methods: {
		handleTabChange(tab) {
			// Optional: Handle tab change events
			console.log('Tab changed to:', tab);
		}
	}
}
</script>
